import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { textSpanIntersectsWithPosition } from 'typescript';


@Injectable({
  providedIn: 'root'
})
export class LogsService {
  private api_local = 'http://localhost:3800';
  private api_prod = environment.api;
  private api = this.api_prod+'/api/logs/';

  constructor(
    private http: HttpClient
  ) { }

  getLogsApi(dateStart?, dateEnd?) {

  }
  
  getLogsCacao(_page, _pagination, _dateStart?, _dateEnd?, _method?, _cardNumber?, _code?, _onlyErrors?) {
    console.log(this.api);
    return this.http.post(this.api + 'cacao', {
      page: _page,
      pagination: _pagination,
      dateStart: _dateStart,
      dateEnd: _dateEnd,
      method: _method,
      cardNumber: _cardNumber,
      code: _code,
      onlyErrors: _onlyErrors
    });
  }

}
